"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTransactionWithTransfersFtTransfersToJSON = exports.AddressTransactionWithTransfersFtTransfersFromJSONTyped = exports.AddressTransactionWithTransfersFtTransfersFromJSON = void 0;
const runtime_1 = require("../runtime");
function AddressTransactionWithTransfersFtTransfersFromJSON(json) {
    return AddressTransactionWithTransfersFtTransfersFromJSONTyped(json, false);
}
exports.AddressTransactionWithTransfersFtTransfersFromJSON = AddressTransactionWithTransfersFtTransfersFromJSON;
function AddressTransactionWithTransfersFtTransfersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asset_identifier': json['asset_identifier'],
        'amount': json['amount'],
        'sender': !runtime_1.exists(json, 'sender') ? undefined : json['sender'],
        'recipient': !runtime_1.exists(json, 'recipient') ? undefined : json['recipient'],
    };
}
exports.AddressTransactionWithTransfersFtTransfersFromJSONTyped = AddressTransactionWithTransfersFtTransfersFromJSONTyped;
function AddressTransactionWithTransfersFtTransfersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_identifier': value.asset_identifier,
        'amount': value.amount,
        'sender': value.sender,
        'recipient': value.recipient,
    };
}
exports.AddressTransactionWithTransfersFtTransfersToJSON = AddressTransactionWithTransfersFtTransfersToJSON;
//# sourceMappingURL=AddressTransactionWithTransfersFtTransfers.js.map